export const country = {
  id: {
    language: 'id_ID',
    country: 'ID',
    domain: 'id',
    acceptLanguage: 'id-ID',
    dialCode: '+62',
    timezone: 'Asia/Jakarta',
    locale : 'id',
    maxDecimal: 2,
    minDecimal: 0,
    decimalSeparator: ",",
    thousandSeparator: ".",
    mask: "separator.2",
    validation: /^[0-9]*(\,[0-9]{0,1})?$/,
    paymentGateway : 'doku',
    showPayment : true ,
  },
  ai: {
    language: 'en_US',
    country: 'MY',
    domain: 'ai',
    acceptLanguage: 'en-US',
    dialCode: '+60',
    timezone: 'Asia/Kuala_Lumpur',
    locale : 'en',
    maxDecimal: 2,
    minDecimal: 2,
    decimalSeparator: ".",
    thousandSeparator: ",",
    mask: "separator.2",
    validation: /^[0-9]*(\.[0-9]{0,1})?$/,
    paymentGateway : 'razerpay',
    showPayment : false ,
  },
  id_ID : "id-ID",
  en_US : "en-US",
} as const;
